import Icon from "../../../../UI/Icon/Icon";
import classes from "./PriceListItem.module.scss";

const PriceListItem = ({
  id,
  name,
  price,
  size,
  quantity,
  priceWithoutDiscount,
  onRemove,
  onReduceItemQuantity,
  onIncreaseItemQuantity,
}) => {
  let smallName = name.substring(0, 20).trim();
  let continueName = null;

  if (name.length > 20) {
    continueName = "...";
  }
  return (
    <div className={classes.PriceListItem}>
      <span>{id}</span>
      <p className={classes.ItemName}>
        {smallName}
        {continueName}
      </p>
      <div className={classes.QuantityButtons}>
        <button
          disabled={quantity <= 1}
          onClick={() => onReduceItemQuantity(id)}
        >
          &#8722;
        </button>
        <strong>{quantity}</strong>
        <button onClick={() => onIncreaseItemQuantity(id)}>&#43;</button>
      </div>
      <p className={classes.ItemDiscountPrice}>{price}</p>
      <button onClick={() => onRemove(id - 1)} className={classes.CloseIcon}>
        <Icon name="cross" />
      </button>
      {size && <p className={classes.ItemSize}>{size}</p>}
      {size && priceWithoutDiscount && (
        <p className={classes.ItemActualPrice}>{priceWithoutDiscount}</p>
      )}
    </div>
  );
};

export default PriceListItem;
